import { TMastersActions } from './masters.action';
import { MastersActionType, TMastersState } from './masters.models';

const initialMastersState: TMastersState = {
  commonMastersData: {
    PRODUCT_TYPE: null,
    OPERATION: null,
    PART: null,
    MACHINE: null,
    STYLE_NO: null,
  },
  fatigueAllowanceListingInfo: null,
  bundleAllowanceInfo: null,
};

export function mastersReducer(state = initialMastersState, action: TMastersActions): TMastersState {
  switch (action.type) {
    case MastersActionType.FetchCommonMasterListingSuccess:
      return {
        ...state,
        commonMastersData: {
          ...state.commonMastersData,
          [action.payload.type]: action.payload.res,
        },
      };
    case MastersActionType.FetchFatigueAllowanceListSuccess:
      return { ...state, fatigueAllowanceListingInfo: action.res };
    case MastersActionType.FetchBundleAllowanceSuccess:
      return { ...state, bundleAllowanceInfo: action.res };
    default:
      return state;
  }
}
